import { render, staticRenderFns } from "./selectSectionType.vue?vue&type=template&id=db4f82c0&scoped=true&"
import script from "./selectSectionType.vue?vue&type=script&lang=js&"
export * from "./selectSectionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4f82c0",
  null
  
)

export default component.exports